import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import axios from '@/utils/request'
import $ from 'jquery'

import '@/assets/font/iconfont.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import * as custom from '@/utils/date'
// 全局注册
Object.keys(custom).forEach(key => { Vue.filter(key, custom[key])})
import '@/assets/style/base.css'
import '@/assets/style/common.css'
// import '@/assets/style/indexSwiper.css'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'N1Li3hYXGaZKMp1ucHnRvq5FPnVxFO1a'
})
import * as echarts from 'echarts'
import 'echarts/map/js/china'
Vue.prototype.$echarts = echarts

Vue.prototype.$http = axios

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  // store,
  $,
  render: h => h(App)
}).$mount('#app')
